import './style.scss';

import React, { Fragment } from 'react';
import _ from 'lodash';
import Modal from 'react-modal';
import { getSimilarProducts } from 'shared/models/api';
import PriceDisplay from 'shared/components/product/priceDisplay';
import ProductQtySelector from 'shared/components/product/qtySelector';
import QtyDiscount from 'shared/components/product/qtyDiscount';
import Carousel from 'shared/components/ui/carousel';

class QuickView extends React.Component {
  constructor(props) {
    super(props);
    this.noop = () => {};

    this.state = {
      loadingRecommendations: false,
      recommendations: []
    };

    this.renderOption = this.renderOption.bind(this);
    this.renderValue = this.renderValue.bind(this);
    this.addToCart = this.addToCart.bind(this);
    this.changeProduct = this.changeProduct.bind(this);
    this.close = this.props.close.bind(this);
  }

  componentDidMount() {
    const sku = this.props.product && this.props.product.sku_id;
    if (sku) this.getRecommendations(sku);
  }

  componentWillReceiveProps(nextProps) {
    const nextSku = nextProps.product && nextProps.product.sku_id;
    const prevSku = this.props.product && this.props.product.sku_id;
    if (nextSku && nextSku !== prevSku) this.getRecommendations(nextSku);
  }

  getRecommendations(sku) {
    this.setState({ loadingRecommendations: true });
    getSimilarProducts(sku).then(recommendations =>
      this.setState({
        recommendations,
        loadingRecommendations: false
      })
    );
  }

  renderOption(item) {
    return <div className="product-qty">{item.value}</div>;
  }

  renderValue(item) {
    return (
      <div className="product-qty">
        Quantity <span className="product-qty-number">{item.value}</span>
      </div>
    );
  }

  addToCart(qty) {
    return this.props.addToCart(this.props.product, qty).then(this.close);
  }

  changeProduct(product) {
    this.props.changeProduct(product);
    this.scrollable.scrollTop = 0;
  }

  render() {
    const product = this.props.product || {};

    return (
      <Modal
        overlayClassName="modal-overlay"
        className="modal-content modal-content--quick-view"
        isOpen={!_.isEmpty(product)}
        onRequestClose={this.close}
        shouldCloseOnOverlayClick={true}
        contentLabel="View Product"
        ariaHideApp={false}
      >
        <button
          type="button"
          className="btn--inline right quick-view__cancel"
          onClick={this.close}
        >
          ×
        </button>

        <div
          className="quick-view__content"
          ref={div => (this.scrollable = div)}
        >
          <div className="row text-left">
            <div className="col-xs-12 col-sm-6">
              <img
                className="quick-view__image"
                src={product.image_large}
                alt={product.title}
              />
            </div>

            <div className="col-xs-12 col-sm-6">
              <div className="quick-view__details">
                <QuickViewSummary product={product} />

                {product.soldout ? (
                  <span className="error">Sold Out</span>
                ) : !product.price ? (
                  <span className="error">
                    Product not available at your location
                  </span>
                ) : (
                  <Fragment>
                    {!!product.package_qty && (
                      <QtyDiscount
                        product={product}
                        textProps={{ tag: 'p', weight: 'med' }}
                      />
                    )}
                    <ProductQtySelector
                      buttonText="Add to Cart"
                      buttonAction={this.addToCart}
                    />
                  </Fragment>
                )}
              </div>
            </div>
          </div>

          {!this.state.loadingRecommendations &&
            !!this.state.recommendations.length && (
              <section className="quick-view__recommendations text-left">
                <h3 className="quick-view__recommendations-heading">
                  Related Items
                </h3>
                <Carousel>
                  {this.state.recommendations.map(product => (
                    <div
                      key={product.sku_id}
                      className="quick-view-recommendation__container"
                    >
                      <div
                        className="quick-view-recommendation__card"
                        onClick={() => this.changeProduct(product)}
                      >
                        <img
                          className="quick-view-recommendation__image"
                          src={product.image}
                        />
                        <div className="quick-view-recommendation__details">
                          <div className="quick-view-recommendation__subtitle text-bold">
                            {product.title}
                          </div>
                          <div className="quick-view-recommendation__subtitle">
                            {product.subtitle}
                          </div>
                          <div>
                            <span>{product.volume}</span>
                            <PriceDisplay product={product} />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </Carousel>
              </section>
            )}
        </div>
      </Modal>
    );
  }
}

export function QuickViewSummary({ product }) {
  return (
    <Fragment>
      <h1 className="quick-view__title">{product.title}</h1>
      <h2 className="quick-view__subtitle">
        <span>
          {product.subtitle} | {product.volume}
        </span>
        <PriceDisplay product={product} />
      </h2>
      <p className="quick-view__description">{product.description}</p>
    </Fragment>
  );
}

export default QuickView;



// WEBPACK FOOTER //
// ./shared/components/quickView/index.js